export default "__VITE_ASSET__CAMF1HWv__"